const DailyCountsObject = ({ count = null, timestamp = '' }) => ({
  count: count && Number(count),
  timestamp: String(timestamp),
});

const Counts = ({ dailyCounts = [], percentChange = 0 }) => ({
  dailyCounts: dailyCounts.map(DailyCountsObject),
  percentChange: Number(percentChange),
});

const PremiumComps = ({
  cityState = {},
  comps = {},
  days = 0,
  hasEnoughListings = false,
  hasListings = false,
  showComps = false,
}) => ({
  cityState: Counts(cityState),
  comps: Counts(comps),
  days: Number(days),
  hasEnoughListings: Boolean(hasEnoughListings),
  hasListings: Boolean(hasListings),
  showComps: Boolean(showComps),
});

export default PremiumComps;

export type PremiumCompsProps = ReturnType<typeof PremiumComps>;
